module.exports = __webpack_public_path__ + "static/media/areas04.9db2625f.jpg";